// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"167":"detail","177":"home"}[chunkId] + "." + {"167":"6dd02405","177":"4da630da"}[chunkId] + ".css";
};